import { render, staticRenderFns } from "./resetEmailbyAdmin.vue?vue&type=template&id=2ab273f2&"
import script from "./resetEmailbyAdmin.vue?vue&type=script&lang=js&"
export * from "./resetEmailbyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./resetEmailbyAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports